var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.9999H5C4.44772 21.9999 4 21.5521 4 20.9999V11.4139C4 11.1487 4.10545 10.8944 4.293 10.7069L11.293 3.70686C11.4806 3.51908 11.7351 3.41357 12.0005 3.41357C12.2659 3.41357 12.5204 3.51908 12.708 3.70686L19.708 10.7069C19.8957 10.8941 20.0009 11.1487 20 11.4139V20.9999C20 21.5521 19.5523 21.9999 19 21.9999ZM10 14.9999H14V19.9999H18V11.8279L12 5.82786L6 11.8279V19.9999H10V14.9999Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4aa9efe35fb8d4c5d4e857c2dede0a88.svg";
export { ForwardRef as ReactComponent };